import { dataHooks } from '../../../../libs/dataHooks';

export const filterDropdownDataHooks = dataHooks<{
  title: {};
  dropdown: {};
}>('filter-wrapper');
